<!--
 * @Author: Viviyaaaa 870951135@qq.com
 * @Date: 2024-04-12 10:05:08
 * @LastEditors: Viviyaaaa 870951135@qq.com
 * @LastEditTime: 2024-04-13 20:02:06
 * @FilePath: \demo\src\pages\type\style\Flat.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div class="brand-box">
    <div class="mySwiper">
      <ul class="swiper-wrapper">
        <li class="swiper-slide" v-for="(item,idxs) in imgList" :key="idxs">
          <img  :src="require('@/assets/images/brand/' + item)" alt="">
        </li>
      </ul>
    </div>
  </div>
</template>

<script >
import Swiper from 'swiper';
import '@/swiper/swiper-bundle.min.css';
export default{
  name: 'Flat',
  data(){
    return {
      imgList:['1.jpg','2.jpg','3.jpg','4.jpg', '5.jpg', '6.jpg'],
      selectIdx:0
    }
  },
  mounted() {
    var that = this
    this.swiper = new Swiper(".mySwiper", {
      on: {
        slideChange: function(){
          that.selectIdx = this.activeIndex 
        },
        }

    });
  }
}
</script>

<style lang="scss" scoped>
.brand-box {
  overflow: hidden;
  position: absolute;
  height: 100vh;
  width:100vw;
  background-color: rgb(2,1,1);
  .tab-box {
    display: flex;
    position: absolute;
    z-index: 999;
    left: 50%;
    transform: translateX(-50%);
    top: 3rem;
    li {
      display: flex;
      justify-content: center;
      align-items: center;
      width:3rem;
      height:1.5rem;
      border-radius: 0.8rem;
      background-color: rgba(0, 0, 0, 0.7);
      color: #fff;
      margin-right: 2rem;
      font-size: 0.5rem;
      // img {
      //   width:100%;
      // }

    }

    .selected {
      background-color: rgb(243, 202, 126);
    }
  }
  :deep(.swiper-wrapper){
    li {
      img {
        width: 100vw;
        height: 100vh;
        
      }
    }
  }
}

</style>
